export default "__VITE_ASSET__8f50ba53__"